import { render, staticRenderFns } from "./BaseValidInput.vue?vue&type=template&id=6bc5e424&"
import script from "./BaseValidInput.vue?vue&type=script&lang=js&"
export * from "./BaseValidInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports